import { createStyles, DialogActions as MuiDialogActions, makeStyles } from '@material-ui/core';
import React from 'react';

import { topBorderStyle } from '../../../theme';
import { CancelButton } from './CancelButton';

type Props = {
  cta: React.ReactNode;
  children?: React.ReactNode;
};

export const DialogActions = ({ children, cta }: Props): React.ReactElement => {
  const classes = useStyles();

  return (
    <MuiDialogActions className={classes.root}>
      {children}
      <CancelButton />
      {cta}
    </MuiDialogActions>
  );
};

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      ...topBorderStyle,
    },
  })
);
